import React, { useState } from 'react';
import {
  DialogContent,
  TextField,
  Grid,
  Button,
  MenuItem,
  FormControlLabel,
  Switch
} from '@mui/material';
import { authenticationService } from 'src/services';

interface VendorStream {
  id?: string;
  vendorId: any;
  url: string;
  name: string;
  streamEngine: string;
  streamPath:string;
  channelPort: string;
  apiPort: string;
  createdDate?: string;
  franchiseId: any;
  channelCount: string;
  mediaServerUrl: string;
  mediaServerChannelPort: string;
  publicUrl: string;
  publicChannelPort: string;
  keyStorePath?: string;
  serverUserName?: string;
  serverPassword?: string;
  serverType: string;
  priority: string;
  serverRole: string;
  isActive: boolean;

}

interface AddVendorStreamDialogProps {
  onSubmit: (stream: Omit<VendorStream, 'id' | 'createdDate'>) => void;
  onClose: () => void;
}

const AddVendorStreamDialog: React.FC<AddVendorStreamDialogProps> = ({ onSubmit, onClose }) => {

  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();
  const [stream, setStream] = useState<Omit<VendorStream, 'id' | 'createdDate'>>({
    vendorId: vendorId,
    url: '',
    name: '',
    serverType: '',
    streamPath:'',
    channelPort: '',
    streamEngine: 'OTHER',
    apiPort: '',
    franchiseId: franchiseId,
    channelCount: '',
    mediaServerUrl: '',
    mediaServerChannelPort: '',
    publicUrl: '',
    publicChannelPort: '',
    keyStorePath: '',
    serverUserName: '',
    serverPassword: '',
    priority: '1',
  serverRole: 'MAIN',
  isActive: true
  });

  const [errors, setErrors] = useState({
    url: '',
    name: '',
    serverType: '',
    channelPort: '',
    apiPort: '',
    channelCount: '',
    mediaServerUrl: '',
    mediaServerChannelPort: '',
    publicUrl: '',
    publicChannelPort: '',
  });

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  setStream(prev => ({
    ...prev,
    isActive: e.target.checked,
  }));
};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setStream(prev => ({ ...prev, [name]: value }));
    
    // Clear error when user starts typing
    if (errors[name as keyof typeof errors]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const TYPE_OPTIONS = [
  { label: 'DRM', value: 'DRM' },
  { label: 'CRM', value: 'CRM' },
  { label: 'STREAM', value: 'STREAM' },
  { label: 'Media Server', value: 'MEDIA_SERVER' },
  { label: 'Backup Server', value: 'BACKUP_SERVER' },
  { label: 'Others', value: 'OTHER' },
];

  const validateForm = () => {
    const newErrors = {
      url: '',
      name: '',
      serverType: '',
      channelPort: '',
      apiPort: '',
      channelCount: '',
      mediaServerUrl: '',
      mediaServerChannelPort: '',
      publicUrl: '',
      publicChannelPort: '',
    };

    let hasError = false;

    if (!stream.serverType.trim()) {
  newErrors.serverType = 'Please select serverType';
  hasError = true;
}

    //  fields validation - just like user form
    if (!stream.url.trim()) {
      newErrors.url = 'Please enter URL';
      hasError = true;
    } else if (!/^(http|https):\/\/[^\s$.?#].[^\s]*$/.test(stream.url)) {
      newErrors.url = 'Enter a valid URL starting with http:// or https://';
      hasError = true;
    }

    if (!stream.name.trim()) {
      newErrors.name = 'Please enter name';
      hasError = true;
    }

    

    /* if (!stream.channelPort.trim()) {
      newErrors.channelPort = 'Please enter channel port';
      hasError = true;
    } else if (!/^\d+$/.test(stream.channelPort)) {
      newErrors.channelPort = 'Port must be a number';
      hasError = true;
    } else if (parseInt(stream.channelPort) < 1 || parseInt(stream.channelPort) > 65535) {
      newErrors.channelPort = 'Port must be between 1 and 65535';
      hasError = true;
    }
 */

    const isChannelPortRequired =
  stream.streamEngine !== 'HLS' &&
  stream.streamEngine !== 'HLS_EXTERNAL';

if (isChannelPortRequired && !stream.channelPort.trim()) {
  newErrors.channelPort = 'Please enter channel port';
  hasError = true;
} else if (stream.channelPort.trim()) {
  if (!/^\d+$/.test(stream.channelPort)) {
    newErrors.channelPort = 'Port must be a number';
    hasError = true;
  } else if (
    parseInt(stream.channelPort) < 1 ||
    parseInt(stream.channelPort) > 65535
  ) {
    newErrors.channelPort = 'Port must be between 1 and 65535';
    hasError = true;
  }
}
    



    // Optional field validations
    if (stream.apiPort) {
      if (!/^\d+$/.test(stream.apiPort)) {
        newErrors.apiPort = 'Port must be a number';
        hasError = true;
      } else if (parseInt(stream.apiPort) < 1 || parseInt(stream.apiPort) > 65535) {
        newErrors.apiPort = 'Port must be between 1 and 65535';
        hasError = true;
      } 
      // else if (stream.apiPort === stream.channelPort) {
      //   newErrors.apiPort = 'API port cannot be same as channel port';
      //   hasError = true;
      // }
    }

    if (stream.channelCount && !/^\d+$/.test(stream.channelCount)) {
      newErrors.channelCount = 'Must be a number';
      hasError = true;
    }

    if (stream.mediaServerUrl && !/^(http|https):\/\/[^\s$.?#].[^\s]*$/.test(stream.mediaServerUrl)) {
      newErrors.mediaServerUrl = 'Enter a valid URL starting with http:// or https://';
      hasError = true;
    }

    if (stream.mediaServerChannelPort && !/^\d+$/.test(stream.mediaServerChannelPort)) {
      newErrors.mediaServerChannelPort = 'Port must be a number';
      hasError = true;
    }

    if (stream.publicUrl && !/^(http|https):\/\/[^\s$.?#].[^\s]*$/.test(stream.publicUrl)) {
      newErrors.publicUrl = 'Enter a valid URL starting with http:// or https://';
      hasError = true;
    }

    if (stream.publicChannelPort && !/^\d+$/.test(stream.publicChannelPort)) {
      newErrors.publicChannelPort = 'Port must be a number';
      hasError = true;
    }

    setErrors(newErrors);
    return !hasError;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(stream);
    }
  };

  return (
    <DialogContent sx={{marginTop:'5px'}}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              label="URL *"
              name="url"
              value={stream.url}
              onChange={handleChange}
              error={!!errors.url}
              helperText={errors.url}
              
            />
          </Grid>

          <Grid item xs={4} >
            <TextField
              fullWidth
              label="Public URL"
              name="publicUrl"
              value={stream.publicUrl}
              onChange={handleChange}
              error={!!errors.publicUrl}
              helperText={errors.publicUrl}
            />
          </Grid>

          <Grid item xs={4} >
            <TextField
              fullWidth
              label="Media Server URL"
              name="mediaServerUrl"
              value={stream.mediaServerUrl}
              onChange={handleChange}
              error={!!errors.mediaServerUrl}
              helperText={errors.mediaServerUrl}
            />
          </Grid>

           <Grid item xs={4}>
            <TextField
              fullWidth
              label="Name *"
              name="name"
              value={stream.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              
            />
          </Grid>

          <Grid item xs={4} >
            <TextField
              fullWidth
              label="Server Username"
              name="serverUserName"
              value={stream.serverUserName}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={4} >
            <TextField
              fullWidth
              label="Server Password"
              name="serverPassword"
              value={stream.serverPassword}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={4}>
  <TextField
    select
    fullWidth
    label="serverType"
    name="serverType"
    value={stream.serverType}
    onChange={handleChange}
    error={!!errors.serverType}
    helperText={errors.serverType}
    
  >
    {TYPE_OPTIONS.map((type) => (
      <MenuItem key={type.value} value={type.value}>
        {type.label}
      </MenuItem>
    ))}
  </TextField>
</Grid>

<Grid item xs={4} >
  <TextField
    select
    fullWidth
    label="Server Role"
    name="serverRole"
    value={stream.serverRole}
    onChange={handleChange}
  >
    <MenuItem value="MAIN">Main</MenuItem>
    <MenuItem value="BACKUP">Backup</MenuItem>
  </TextField>
</Grid>

 <Grid item xs={4}>
            <TextField
              fullWidth
              label="Stream Path"
              name="streamPath"
              value={stream.streamPath}
              onChange={handleChange}      
            />
          </Grid>

          
          
          <Grid item xs={4}>
            <TextField
              select
              fullWidth
              label="Stream Engine *"
              name="streamEngine"
              value={stream.streamEngine}
              onChange={handleChange}
            >
              <MenuItem value="OTHER">OTHER</MenuItem>
              <MenuItem value="WOWZA">WOWZA</MenuItem>
              <MenuItem value="HLS">HLS</MenuItem>
              <MenuItem value="HLS_EXTERNAL">HLS_EXTERNAL</MenuItem>
            </TextField>
          </Grid>

         

          <Grid item xs={4} >
  <TextField
    select
    fullWidth
    label="Priority"
    name="priority"
    value={stream.priority}
    onChange={handleChange}
  >
    <MenuItem value="1">1</MenuItem>
    <MenuItem value="2">2</MenuItem>
  </TextField>
</Grid>


          
         
      <Grid item xs={4} >
            <TextField
              fullWidth
              label="Channel Count"
              name="channelCount"
              value={stream.channelCount}
              onChange={handleChange}
              error={!!errors.channelCount}
              helperText={errors.channelCount}
            />
          </Grid>
         
          
          
          <Grid item xs={4} >
            <TextField
              fullWidth
              label="Channel Port *"
              name="channelPort"
              value={stream.channelPort}
              onChange={handleChange}
              error={!!errors.channelPort}
              helperText={errors.channelPort}
              
            />
          </Grid>
          
          <Grid item xs={4}>
            <TextField
              fullWidth
              label="API Port"
              name="apiPort"
              value={stream.apiPort}
              onChange={handleChange}
              error={!!errors.apiPort}
              helperText={errors.apiPort}
            />
          </Grid>

           <Grid item xs={4} >
            <TextField
              fullWidth
              label="Public Port"
              name="publicChannelPort"
              value={stream.publicChannelPort}
              onChange={handleChange}
              error={!!errors.publicChannelPort}
              helperText={errors.publicChannelPort}
            />
          </Grid>
          
          

          

          <Grid item xs={4} >
            <TextField
              fullWidth
              label="Media Server Port"
              name="mediaServerChannelPort"
              value={stream.mediaServerChannelPort}
              onChange={handleChange}
              error={!!errors.mediaServerChannelPort}
              helperText={errors.mediaServerChannelPort}
            />
          </Grid>

          

          <Grid item xs={4} >
            <TextField
              fullWidth
              label="Key Store Path"
              name="keyStorePath"
              value={stream.keyStorePath}
              onChange={handleChange}
            />
          </Grid>

          

          

          <Grid
  item
  xs={12}
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 2,
  }}
>
  <FormControlLabel
    control={
      <Switch
        checked={stream.isActive}
        onChange={handleSwitchChange}
        color="primary"
      />
    }
    label="Is Active"
  />

  <div style={{ display: 'flex', gap: 16 }}>
    <Button variant="outlined" onClick={onClose}>
      Cancel
    </Button>
    <Button type="submit" variant="contained" color="primary">
      Add Stream
    </Button>
  </div>
</Grid>
        </Grid>
      </form>
    </DialogContent>
  );
};

export default AddVendorStreamDialog;